async function countyFilterDropdown() {
    const categoryFilterElement = document.querySelectorAll('[data-category-filter]');
    const categoryItemElement = document.querySelectorAll('[data-category-item]');
    const categorySectionElement = document.querySelectorAll('.index-section, .index-items');
    const siteContentElement = document.querySelector('.site-content');
    const categoryFilterToggleText= document.querySelector('.index-filter .index-filter__toggle-text');
    
    categoryFilterElement.forEach((item) => {
        const categoryValue = item.getAttribute('data-category-filter');
        
        item.addEventListener('click', (event) => {
            event.preventDefault();
            categoryFilterElement.forEach(item => {
                item.classList.remove('active');
            });
            item.classList.add('active');
            addRemoveClassOnFilterItem(categoryValue);
    
            categoryFilterToggleText.innerText = item.innerText;

            const filterSelected = new Event('filter-selected');

            // Dispatch the event.
            item.dispatchEvent(filterSelected);
        });
    });

    const pageUrlParam = window.location.search;
    const urlParams = new URLSearchParams(pageUrlParam);
    const countyParam = urlParams.get('county');

    if (countyParam !== null) {
        document.querySelector(`[data-category-filter="${camelize(countyParam.replaceAll('+', ' '))}County"]`).click();
    }
    
    function addRemoveClassOnFilterItem(value) {
        categoryItemElement.forEach(item => {
            item.closest('.index-items__item').classList.remove('js-category-showing');
        });
        
        const activeFilterCategory = document.querySelectorAll('[data-category-item="' + value + '"]');
        activeFilterCategory.forEach(item => {
            item.closest('.index-items__item').classList.add('js-category-showing');
        });
    
        categorySectionElement.forEach(item => {
            const activeFilterElements = item.querySelector('.js-category-showing');
    
            if (activeFilterElements) {
                siteContentElement.classList.add('js-index-filter-entries-showing');
                item.classList.add('js-filter-section-showing');
            } else {
                item.classList.remove('js-filter-section-showing');
                siteContentElement.classList.remove('js-index-filter-entries-showing');
            }
        });
    }
    
    function camelize(str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
        if (+match === 0) return '';
            return index === 0 ? match.toLowerCase() : match.toUpperCase();
        });
    }
}